<template>
  <label class="ocean-ui-editor-default-style" :class="classes">
    <Icon
      :type="beforeIconType"
      class="ocean-ui-list-item-before-icon icon"
      v-if="assignedBeforeIcon"
      :active="active"
      :style="beforeIconStyles"
    ></Icon>
    <input
      class="serviceCheck"
      :class="[editorClass, $platformClass]"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      v-if="!disable"
      :disabled="disable"
      @input="passValToParent($event)"
      @blur="passMethod('blur')"
      :type="editorType || 'text'"
    />
    <output v-if="disable" class="ocean-ui-editor-output" :class="editorClass">
      {{ value }}
    </output>
    <slot></slot>
    <Icon
      :type="afterIconType"
      class="ocean-ui-list-item-after-icon icon"
      v-if="assignedAfterIcon"
      :active="active"
      :style="afterIconStyles"
    ></Icon>
  </label>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
import iconSetting from '../../mixins/iconSetting';
export default {
  mixins: [themeMixins, iconSetting],
  props: [
    'type',
    'placeholder',
    'name',
    'editorClass',
    'editorType',
    'value',
    'beforeIconType',
    'afterIconType',
    'active',
    'leftSpan',
    'rightSpan',
    'disable',
    'inputColor',
  ],
  methods: {
    passValToParent($event) {
      this.$emit('input', $event.target.value);
    },
  },
};
</script>

<style scoped lang="scss">
.ocean-ui-editor-output {
  display: block;
}

.ocean-ui-editor-default-style {
  position: relative;
}

.ocean-ui-list-item-before-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
